import React from 'react';
import { Spin } from 'antd';

export const LoadingScreen: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <Spin />
    </div>
  );
};
